import React from 'react'
import appTypeConfigFunc from 'apptype-config'
import { lazy } from '@loadable/component'
import { isGlobal, isJP } from 'conf'

const config = {
  fallback: <div />,
}

let defaultRoutes = [
  ...(isGlobal()
    ? [
        {
          path: '/auth/signup/verification/email',
          Component: lazy(() => import('pages/basic-auth/signup/verification/email'), config),
        },
        {
          path: '/auth/signup/verification/otp',
          Component: lazy(() => import('pages/basic-auth/signup/verification/otp'), config),
        },
        {
          path: '/auth/signup/register',
          Component: lazy(() => import('pages/basic-auth/signup'), config),
        },
        {
          path: '/auth/changePW/verification/email',
          Component: lazy(() => import('pages/basic-auth/changePW/verification/email'), config),
        },
        {
          path: '/auth/changePW/verification/otp',
          Component: lazy(() => import('pages/basic-auth/changePW/verification/otp'), config),
        },
        {
          path: '/auth/changePW',
          Component: lazy(() => import('pages/basic-auth/changePW'), config),
        },
      ]
    : []),

  {
    path: '/viewer',
    Component: lazy(() => import('pages/viewer'), config),
  },
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login'), config),
    exact: true,
  },
  {
    path: '/auth/sso-auth',
    Component: lazy(() => import('pages/auth/sso-auth'), config),
  },
  {
    path: '/auth/callback',
    Component: lazy(() => import('pages/auth/callback'), config),
  },
  {
    path: '/auth/sso/callback',
    Component: lazy(() => import('pages/auth/callback'), config),
  },
  {
    path: '/masterPW/login',
    Component: lazy(() => import('pages/auth/loginMasterPW'), config),
  },
  {
    path: '/masterPW/changePW',
    Component: lazy(() => import('pages/auth/changeMasterPW'), config),
  },
  {
    path: '/masterPW/verify',
    Component: lazy(() => import('pages/auth/verifyMasterPW'), config),
  },
  {
    path: '/masterPW/register',
    Component: lazy(() => import('pages/auth/registerMasterPW'), config),
  },
  {
    path: '/masterPW/verify/changePW',
    Component: lazy(() => import('pages/auth/verifyMasterPW/changeMasterPW'), config),
  },
  {
    path: '/masterPW/reset',
    Component: lazy(() => import('pages/auth/resetMasterPW'), config),
  },

  {
    path: '/records/all',
    Component: lazy(() => import('pages/records/all'), config),
  },
  {
    path: '/records/mine',
    Component: lazy(() => import('pages/records/mine'), config),
  },
  {
    path: '/records/memo',
    Component: lazy(() => import('pages/records/memo'), config),
  },
  {
    path: '/records/favorites',
    Component: lazy(() => import('pages/records/favorites'), config),
  },
  {
    path: '/records/groups/:id',
    Component: lazy(() => import('pages/records/groups'), config),
  },
  {
    path: '/records/categories/:id',
    Component: lazy(() => import('pages/records/categories'), config),
  },
  {
    path: '/records/:id',
    Component: lazy(() => import('pages/records/detail'), config),
  },
  {
    path: '/records/expired',
    Component: lazy(() => import('pages/records/expired'), config),
  },
  {
    path: '/records/authenticator',
    Component: lazy(() => import('pages/records/authenticator'), config),
  },
  {
    path: '/expired',
    Component: lazy(() => import('pages/expired'), config),
  },
  {
    path: '/ip-blocked',
    Component: lazy(() => import('pages/ip-blocked'), config),
  },

  {
    path: '/sso-test',
    Component: lazy(() => import('pages/sso-test'), config),
  },

  ...(isJP()
    ? [
        {
          path: '/privacy/jp',
          Component: lazy(() => import('pages/privacy-policy-jpn'), config),
        },
      ]
    : []),
]

if (process.env.REACT_APP_TARGET !== 'production') {
  defaultRoutes = [
    ...defaultRoutes,

    {
      path: '/__test/edit',
      Component: lazy(() => import('pages/test/edit'), config),
    },
    {
      path: '/__test/delete-records',
      Component: lazy(() => import('pages/test/delete-records'), config),
    },
    {
      path: '/__test/delete-account',
      Component: lazy(() => import('pages/deleteAccount'), config),
    },
  ]
}

const routeInfo = {
  prev: null,
  map: null,
}

export function clearRoutes() {
  routeInfo.prev = null
  routeInfo.map = null
}

export default function getRoutes() {
  const routerFunc = appTypeConfigFunc().router

  const myRoutes = [...defaultRoutes, ...routerFunc(config)]

  let isChanged = true
  if (routeInfo.prev != null) {
    isChanged = routeInfo.prev.length !== myRoutes.length
    if (isChanged === false) {
      if (routeInfo.map == null) {
        routeInfo.map = {}
        routeInfo.prev.forEach((item) => {
          routeInfo.map[item.path] = item
        })
      }
      isChanged = myRoutes.some((route) => {
        return routeInfo.map[route.path] == null
      })
    }
  }

  if (isChanged === true) {
    routeInfo.prev = myRoutes
    routeInfo.map = null
  } else {
    return routeInfo.prev
  }

  return myRoutes
}
